import _ from 'lodash';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PendingService } from '../../services/pending.service';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { Store,select } from '@ngrx/store';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { LoadingService } from 'app/core/services/loading.service';
import { catchError, first, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { loadPendingCampaignList } from 'app/campaign/features/campaign.actions';
import { selectCampaignList } from 'app/campaign/features/campaign.selectors';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { loadOrgUser } from 'app/dashboard/features/dashboard.actions';

@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.scss']
})
export class PendingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('card', {static: true}) cardRef: ElementRef;
  @ViewChild('pendingCartsDatatable') datatableElement!: ElementRef;

  public activeTab = 'carts';

  public list = [];
  public runDrowCallback = true;

  public takeUntilSubject: Subject<any> = new Subject();
  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  public addOnCapmName = '';
  public selectedCampId = null;
  public campaignList = null;
  public user = null;

  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    first(user => !_.isNull(user)),
  );

  public donations$: any = this.store.pipe(
    select(selectCampaignList),
    map(list => {
      return _.filter(list, { status: 0, type: CAMPAIGN_TYPE.DONATE });
    })
  )

  constructor(
    public element: ElementRef,
    public store: Store,
    public pendingService: PendingService,
    public sharedService: SharedService,
    public loadingService: LoadingService,
    private routeReuseStrategyService: RouteReuseStrategyService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetectionRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
  }

  @HostListener('window:paybee-report-pending-element.refresh', ['$event']) 
  refresh() {
    this.loadingService.transform = false;
    this.pendingService.getReport().pipe(
      tap(() => {
        this.loadingService.transform = true;
      }),
      catchError((error) => {
        this.loadingService.transform = true;
        return error;
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((list: any []) => {
      var oTable = window['$']("#list").DataTable();
      oTable.clear().rows.add(list).draw(false);
    });

    window['$'](this.cardRef.nativeElement).removeClass('disabled');
  }

  ngOnInit(): void {
    const self = this;
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ current, future }) => {
      switch(future.fragment) {
        case "":
          $(`#cartsTabbNav`).tab('show');
          break;
        default:
          $(`#${future.fragment}Nav`).tab('show');
      }

      if(
        current.fragment === future.fragment
        || future.fragment === ""
      ) {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();
        this.takeUntilSubject = new Subject();
  
        this.ngAfterViewInit();
      }
    });

    $(this.element.nativeElement).off('shown.bs.tab', 'a[role="tab"]');
    $(this.element.nativeElement).on('shown.bs.tab', 'a[role="tab"]', ({ target }) => {
        switch(target.id) {
            case 'cartsTabNav':
              self.loadingService.transform = false;
              return self.pendingService.getReport().pipe(
                tap(() => {
                  self.loadingService.transform = true;
                }),
                catchError((error) => {
                  self.loadingService.transform = true;
                  return error;
                }),
                takeUntil(self.takeUntilSubject)
              ).subscribe((list: any[]) => {
                self.list = list;
                window['orgMain'].allPendingCarts = list
                self.runDrowCallback = true;
                self.showDataTable(list);
              });
            case 'pendingsTabNav':
              self.loadingService.transform = false;
              return self.pendingService.getReport().pipe(
                  tap(() => {
                    self.loadingService.transform = true;
                  }),
                  switchMap((list: any[]) => {
                    self.list = list;
                    window['orgMain'].allPendingCarts = list
                    return self.pendingService.getallPendingItemsReport()
                  }),
                  catchError((error) => {
                    self.loadingService.transform = true;
                    return error;
                  }),
                  takeUntil(self.takeUntilSubject)
                ).subscribe(list=>{
                  window['orgMain'].showPendingDataTable(list)
                })
            case 'remindersTabNav':
                return window['orgMain'].schedulePendingReminder();
        }
    });

    const { fragment } = this.route.snapshot
    switch(fragment) {
      case "":
        this.activeTab = "carts";
        break;
      default:
        const activeTab = this.route.snapshot.fragment.slice(0, -3);
        this.activeTab = activeTab; 
        $(`#${activeTab}TabNav`).tab('show');
    }

    this.store.dispatch({
      type: loadPendingCampaignList.type,
      payload: this.sharedService.token
    });

    this.user = window['localOrgData'].user;

    this.donations$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(list=>{
      this.campaignList = list;
      if(this.user && this.user.cartCheckoutAddOnDonation){
        this.selectedCampId = this.user.cartCheckoutAddOnDonationCampaignId;
        this.setSelectedAddOnDonationCamp();
      }
    })
  }

  ngAfterViewInit(): void {
    const self = this;
    const $ = window['$'];

    $(this.element.nativeElement).off("click");
    $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
      event.preventDefault();

      const fragment = $(this).data('fragment');
      self.router.navigate([], { relativeTo: self.route, fragment });
    });

    this.loadingService.transform = false;
    this.pendingService.getReport().pipe(
      tap(() => {
        this.loadingService.transform = true;
      }),
      catchError((error) => {
        this.loadingService.transform = true;
        return error;
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((list: any[]) => {
      this.list = list;
      window['orgMain'].allPendingCarts = list
      self.runDrowCallback = true
      self.showDataTable(list);
    });


    window['orgMain'].schedulePendingReminder();
    window['orgMain'].initDonorSearch();


    if(this.sharedService.token) {
      this.getCurrentUser()
    }
  }

  showDataTable(list) {
    const self = this;
    window['$']("#list").DataTable({
      data: list,
      autoWidth: true,
      pageLength: 10,
      paging: true,
      fixedColumns: {
        left: 1,
      },
      deferRender: true,
      destroy: true,
      order: [[ 6, 'desc' ]],
      dom: "<'table__header--paybee d-flex align-items-center justify-content-between py-3 mb-4'<''B><''f>><'table-responsive't><'table__footer--paybee d-flex align-items-center justify-content-between p-4'ip>",
      buttons: [{
          className: 'btn-copy-code btn btn-outline-grey btn-sm px-2 waves-effect',
          extend: 'excel',
          filename: 'reportPending',
          text: "<i class='fas fa-cloud-download-alt mr-1'></i> Export",
          title: null,
          exportOptions: {
              stripHtml: true,
              columns: "thead th:not(.no-export)",
              orthogonal: 'export'
          }
      }],
      columns: [
          {
            "data": "donorInfo.name",
            render: function (name,type,row){
              if(type === 'display'){
                return `
                  <div class="d-flex"
                    data-toggle="fullNameTooltip"
                    data-placement="top"
                    data-original-title="${name}"
                  >
                      <span class="table-name-container">
                          ${name}
                      </span>
                  </div>
                `
              }
  
              return name;
            },
          },
          {
              "data": "donorInfo",
              "render": function(donorInfo, type, row, table) {
                  return donorInfo.isFakeEmail ?
                      `None<br/><a class="blue-text" id="email_${donorInfo.id}">(assign)</a>`: donorInfo.email

              }
          },
          {
              "data": "items",
              "render": function(items, type, row ) {
                  if(window['utils'].isValidNonEmptyArray(items)) {
                      return "<a class='blue-text small' style='white-space: nowrap;' id='row_" + row.donorInfo.id + "' data-cartId ="+row.id+" data-email ="+row.donorInfo.email+"  onclick='orgMain.pendingCart(this)'>See Cart</a>"
                  }
              }
          },
          {
              "data": "items",
              "type": "num-fmt",
              "render": function(value, type, row ) {
                const { items } = row;
                const pending = _.sumBy(items, function(item) {
                  return _.get(item, 'donationInfo.amount', 0);
                });
                return window['utils'].getAmountDisplay(pending);
              }
          },
          {
              "data": "donorInfo.streetAddress",
              "render": function(data, type, row ) {
                  var addressStr = window['utils'].getStreetAddressText(data);
                  switch(addressStr) {
                    case null:
                    case "":
                      return "NA";
                  }
                  return addressStr;
              }
          },
          {
              "data": "donorInfo.phone",
              "render": function(phone, type, row ) {
                switch(phone) {
                  case null:
                  case "":
                    return "NA";
                }
                return phone;
              }
          },
          {
            "data": "items",
            "render": function(items , type, row) {

              let itemsDateArr = items.map((item)=>{    
                return new Date(item.updated);    
              })

              const maxDate = new Date(
                Math.max.apply(null, itemsDateArr),
              );  

              return (moment(new Date(maxDate))).format("YYYY/MM/DD h:mm a")
            }
          },
          {
            "data": "lastReminded",
            "render": function(items , type, row) {
              let lastRemindedOn = row.lastReminded
              const year = parseInt(lastRemindedOn.substr(0, 4));

              if(year < 2022){
                return 'NA'
              }else{
                let remindedDate = new Date(lastRemindedOn)
                return (moment(new Date(remindedDate))).format("YYYY/MM/DD h:mm a")
              }
            }
          },
          {
            "data": "reminderCount",
            "render": function(items , type, row) {
              let reminderCount = row.reminderCount
              if(reminderCount){
                return reminderCount
              }else{
                return 0
              }
            }
          },
          {
              "data": "id",
              "createdCell": function(cell, cellData, rowData, row, col){
                let reminderButton = $(cell.firstChild).find('.open-cart-reminder');
                reminderButton.off('click').on('click', function(){
                  window['orgMain'].showCartReminderModalPage(rowData.donorInfo.name, rowData.donorInfo.id,undefined, true)
                })
            },
              "render": function(id, type, row ) {
                if(type == "export") {
                  return window.location.protocol + "//" + window.location.hostname 
                      + "/quickpay.html?cartId=" + id 
                      + "&org=" + window['localOrgData'].user.handle
                } else {
                  var link = `${window.location.protocol}//${window.location.hostname}/quickpay.html?cartId=${id}&org=${window['localOrgData'].user.handle}`
                    var buttonTemplate = "<div  x-placement='bottom-end' id='dropdown_" + id + "'>\
                    <a id='dropdown_toggle_" + id + "' class='blue-text'  type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>\
                        Link\
                    </a>\
                    <div style='visibility:hidden' id='dropdown_menu_" + id + "' class='dropdown-menu py-2 dropdown-menu-right' aria-labelledby='dropdownMenuMenu'>\
                        <a class='dropdown-item' href='%openLink%' target='_blank'><i class='fas fa-globe mr-2'></i>Open in new tab</a>\
                        <div type='button' onclick='%onclickCopyToClickboardToaster%'><button class='dropdown-item'  type='button' onclick='%onclickCopyToClickboard%'><i class='far fa-copy mr-2'></i>Copy Link</button></div>\
                        <div type='button'><button class='dropdown-item open-cart-reminder'  type='button'><i class='fas fa-paper-plane mr-2'></i>Send Cart Reminder...</button></div>\
                    </div>\
                    </div>" 
            
               var btnData = {
                  "%openLink%"                       : `${window.location.protocol}//${window.location.hostname}/quickpay.html?cartId=${id}&org=${window['localOrgData'].user.handle}`,
                  "%onclickCopyToClickboardToaster%" : 'toastr.success("Link was copied")',
                  "%onclickCopyToClickboard%"        : `copyToClipboard("${link}")`,
                }
                return buttonTemplate.replace(/%\w+%/g, function(all) {
                  if(typeof(btnData[all]) != 'undefined')
                      return btnData[all];
                  else
                      return all;
              });
                }
              }
          }
      ],
      "drawCallback":function() {
        if(!self.runDrowCallback){
          self.runDrowCallback = true
          return
        }

        window['$']('.dataTables_filter input').off("keyup")
        window['$']('.dataTables_filter input').keyup(function() {
          let value = window['$'](this).val();
          self.saveQuery(value,'list');
          window['$']("#list").DataTable().search(value).draw(true);
        });

        window['$']('.dataTables_filter input').off("click")
        window['$']('.dataTables_filter input').click(function() {
          setTimeout(()=>{
            let newValue = window['$'](this).val();
            if(newValue == ''){
              self.clearQuery()
              window['$']("#list").DataTable().search('').draw(true);
            }
          },500)
        });

        let dropdown = null;
        let dropdownMenu = null;

        window['$']('#list').off('page.dt');
        window['$']('#list').on('page.dt', function () {

            if(dropdown) {
                dropdown.append(dropdownMenu);
                dropdownMenu.css('visibility', 'hidden');
            }
        });

        window['$']("*[id^='dropdown_']").off("show.bs.dropdown");
        window['$']("*[id^='dropdown_']").on("show.bs.dropdown", function() {
            const [,id] = this.id.split("_");
            const menu = window['$'](`#dropdown_menu_${id}`);
            window['$'](document.body).append(menu);
        });
        window['$']("*[id^='dropdown_']").off("shown.bs.dropdown");
        window['$']("*[id^='dropdown_']").on("shown.bs.dropdown", function() {
            const [,id] = this.id.split("_");
            const menu = window['$'](`#dropdown_menu_${id}`);
            setTimeout(() => {
                menu.css('visibility', 'visible');
                dropdown = window['$'](`#dropdown_${id}`);
                dropdownMenu = menu;
            })
        });
        window['$']("*[id^='dropdown_']").off("hide.bs.dropdown");
        window['$']("*[id^='dropdown_']").on("hide.bs.dropdown", function() {
            const [,id] = this.id.split("_");
            const menu = window['$'](`#dropdown_menu_${id}`);
            window['$'](`#dropdown_${id}`).append(menu);
        });
        window['$']("*[id^='dropdown_']").off("hidden.bs.dropdown");
        window['$']("*[id^='dropdown_']").on("hidden.bs.dropdown", function() {
            const [,id] = this.id.split("_");
            const menu = window['$'](`#dropdown_menu_${id}`);
            setTimeout(() => {
                menu.css('visibility', 'hidden');
                dropdown = null;
                dropdownMenu = null;
            })
        });

        window['$']("#list").show();

        const list_filter = self.pendingService.getSearchQuery('list_filter');
        if(list_filter){
          self.runDrowCallback = false;
          window['$']("#list").DataTable().search(list_filter).draw(true);
        }

        const datatableEl = self.datatableElement.nativeElement as HTMLElement;
        const scrollContainer = datatableEl.parentElement;
    
        if (scrollContainer) {
          window['dataTableService'].registerScrollEvent(window['$'](scrollContainer));
        }

        setTimeout(() => {
          window['dataTableService'].scrollCallback(window['$'](scrollContainer))

          window['$']('[data-toggle="fullNameTooltip"]')
           .filter(function () {
              const container = this.querySelector('.table-name-container');
              return container && container.scrollWidth > container.offsetWidth;
            })
            .tooltip();
        })
      }
    })
  }

  getCurrentUser(){
    this.store.dispatch({
      type:loadOrgUser.type,
      payload:{reload:true}
    })
  }

  onClickAddOnDonation(){
    const action = DialogActions.openDialog({
      payload: {
        name: "AddOnDonation",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-md',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          selectedCampId:this.selectedCampId,
          callback: ({campaignId,name,enable}:any) => {
           
            if(enable){
              this.selectedCampId = campaignId
              this.addOnCapmName = name
            }else{
              this.addOnCapmName = ''
              this.selectedCampId = null;
            }

            let data = {campaignId,enable}
            this.pendingService.addOnDonation(data).pipe(takeUntil(this.takeUntilSubject)).subscribe((val) => {
              this.getCurrentUser();
            }); 
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  setSelectedAddOnDonationCamp(){
    if(this.selectedCampId && this.campaignList){
      let selectedCamp = this.campaignList.find((cam)=>(cam.id == this.selectedCampId ))
      if(selectedCamp){
        this.selectedCampId = selectedCamp.id
        this.addOnCapmName = selectedCamp.name
      }
    }
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  sendCartReminderAll(card: ElementRef) {
    window['orgMain'].showSendCartReminderAllModal({ }, 'allPendingCarts');
  }

  onClickAddPending() {
    const action = DialogActions.openDialog({
      payload: {
        name: "AddPending",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          callback: (data) => {
            this.pendingService.addToCart(data).pipe(takeUntil(this.takeUntilSubject)).subscribe(() => {
              setTimeout(()=>{
                this.router.navigateByUrl('/reportPendingCarts')
              },400)
            });
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  saveQuery(query,callFrom){
    if(callFrom == 'list'){
      this.pendingService.saveSearch('list_filter',query)
    }else if(callFrom == 'pendings'){
      this.pendingService.saveSearch('list_filter_pending',query)
    }
   
  }
  clearQuery(){
    this.pendingService.clearSearchQuery()
  }
}